function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

import "antd/es/input/style";
import _Input from "antd/es/input";

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  Object.defineProperty(subClass, "prototype", {
    value: Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    }),
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import 'rmc-picker/assets/index.css';
import './date-picker/index.css';
import 'rmc-picker/assets/popup.css';
import React, { Component } from 'react';
import RCDatePicker from './date-picker/DatePicker';
import PopupDatePicker from './date-picker/Popup';
import zh from './date-picker/locale/zh_CN';
import { formatFn } from './utils';
import PickerIcon from './icon';

var MDatePicker = /*#__PURE__*/function (_Component) {
  _inherits(MDatePicker, _Component);

  var _super = _createSuper(MDatePicker);

  function MDatePicker(props) {
    var _this;

    _classCallCheck(this, MDatePicker);

    _this = _super.call(this, props);
    _this.state = void 0;
    _this.state = {
      visible: false,
      date: props.defaultValue ? new Date(props.defaultValue) : undefined
    };
    return _this;
  }

  _createClass(MDatePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          style = _this$props.style,
          _this$props$mode = _this$props.mode,
          mode = _this$props$mode === void 0 ? 'datetime' : _this$props$mode,
          readOnly = _this$props.readOnly,
          disabled = _this$props.disabled,
          _this$props$placehold = _this$props.placeholder,
          placeholder = _this$props$placehold === void 0 ? "请选择日期" : _this$props$placehold,
          _this$props$useSecond = _this$props.useSeconds,
          useSeconds = _this$props$useSecond === void 0 ? false : _this$props$useSecond,
          format = _this$props.format,
          _this$props$minDate = _this$props.minDate,
          minDate = _this$props$minDate === void 0 ? new Date(1900, 1, 1, 0, 0, 0) : _this$props$minDate,
          _this$props$maxDate = _this$props.maxDate,
          maxDate = _this$props$maxDate === void 0 ? new Date(2100, 1, 1, 23, 59, 59) : _this$props$maxDate,
          _onChange = _this$props.onChange;
      var datePicker = /*#__PURE__*/React.createElement(RCDatePicker, {
        useSeconds: useSeconds,
        mode: mode,
        maxDate: maxDate,
        minDate: minDate,
        locale: zh,
        use12Hours: false
      });
      style = Object.assign({
        maxWidth: mode === 'datetime' ? 200 : 130
      }, style || {});
      var readonly = readOnly || disabled;
      var PickerWrapper = readonly ? React.Fragment : PopupDatePicker;
      return /*#__PURE__*/React.createElement(PickerWrapper, {
        onChange: function onChange(date) {
          _this2.setState({
            date: date
          });

          _onChange && _onChange(date, formatFn(date, mode, format, useSeconds));
        },
        date: this.state.date || new Date(),
        okText: "\u786E\u5B9A",
        dismissText: "\u53D6\u6D88",
        visible: this.state.visible,
        onVisibleChange: function onVisibleChange() {
          return _this2.setState({
            visible: !_this2.state.visible
          });
        },
        datePicker: datePicker
      }, /*#__PURE__*/React.createElement(_Input, {
        disabled: disabled,
        placeholder: placeholder,
        value: formatFn(this.state.date, mode, format, useSeconds),
        readOnly: true,
        style: style,
        suffix: /*#__PURE__*/React.createElement(PickerIcon, {
          style: {
            right: 0
          },
          className: "ant-calendar-picker-icon ant-picker-suffix"
        })
      }));
    }
  }]);

  return MDatePicker;
}(Component);

export default MDatePicker;